/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Prompt_Title_OrganizerInputs */



/**
* | output |
* | --- |
* | "Get notified when a player needs a judge" |
*
* @param {Notifications_Prompt_Title_OrganizerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_prompt_title_organizer = /** @type {((inputs?: Notifications_Prompt_Title_OrganizerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Prompt_Title_OrganizerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Soyez notifié(e) quand un joueur demande l’arbitre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reciba avisos cuando un jugador llame al juez")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Receba avisos quando um jogador chamar o juiz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ricevi un avviso quando un giocatore chiama il giudice")
	return /** @type {LocalizedString} */ ("Get notified when a player needs a judge")
});